export class AssignmentQueue {
  id: number;
  coderId: number;
  userId: number;
  userName: string;
  coderName: string;
  email: string;
  phoneNumber: string;
  coderLevel: string;
  qaNeeded: string;
  assignedClients: number[];
  assignedProjects: number[];
  clientNames: string;
  projectNames: string;
  updatedBy:string;
}